const styles = theme => ({
  root: {
    display: 'flex',
    borderRadius: '16px',
    boxShadow:
      '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
    width: '100%',
    padding: '24px',
    minHeight: 'calc(80vh - 40px)',
    marginBottom: '16px',
    [`@media (max-width: 1440px)`]: {
      flexDirection: 'column',
    },
    [`@media (max-width: 1024px)`]: {
      padding: '16px',
      minHeight: 'calc(100vh - 180px)',
    },
    [`@media (max-width: 768px)`]: {
      padding: '12px',
      gap: '12px',
      minHeight: 'calc(100vh - 160px)',
      borderRadius: '12px',
    },
    [`@media (max-width: 480px)`]: {
      padding: '8px',
      gap: '8px',
      minHeight: 'calc(100vh - 140px)',
      borderRadius: '8px',
    },
  },
  content: {
    flex: 1,
    padding: '0 24px',
    overflow: 'auto',
    maxWidth: '640px',
    [`@media (max-width: 1440px)`]: {
      padding: '0px',
    },
    [`@media (max-width: 768px)`]: {
      '& .MuiFormControl-root': {
        marginBottom: '16px',
        width: '100%',
      },
      '& .MuiInputBase-root': {
        fontSize: '14px',
      },
      '& .MuiButton-root': {
        fontSize: '14px',
        padding: '6px 16px',
        width: '100%',
        marginTop: '8px',
      },
      '& > div > div': {
        // Target SharePopover's inner content
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
      },
      '& .MuiTextField-root': {
        width: '100%',
      },
      '& .MuiDivider-root': {
        margin: '12px 0',
      },
    },
    [`@media (max-width: 480px)`]: {
      '& .MuiFormControl-root': {
        marginBottom: '12px',
      },
      '& .MuiInputBase-root': {
        fontSize: '13px',
      },
      '& .MuiButton-root': {
        fontSize: '13px',
        padding: '4px 12px',
      },
      '& > div > div': {
        gap: '8px',
      },
      '& .MuiDivider-root': {
        margin: '8px 0',
      },
    },
  },
  leftSideList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    borderRight: '1px solid #E0E0E0',
    padding: '0px 24px 0px 0px',
    [`@media (max-width: 1440px)`]: {
      display: 'none',
    },
  },
  leftSideListItem: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    padding: '8px',
    borderRadius: '8px',
    cursor: 'pointer',
    minWidth: '192px',
    '&:hover': {
      backgroundColor: '#E3F3FF',
    },
  },
  active: {
    backgroundColor: '#E3F3FF',
  },
  mobileSelect: {
    display: 'none',
    width: '100%',
    [`@media (max-width: 1440px)`]: {
      display: 'block',
    },
    [`@media (max-width: 768px)`]: {
      marginBottom: '16px',
      '& .MuiInputLabel-root': {
        fontSize: '14px',
      },
      '& .MuiSelect-root': {
        fontSize: '14px',
        padding: '10px 14px',
      },
    },
    [`@media (max-width: 480px)`]: {
      marginBottom: '12px',
      '& .MuiInputLabel-root': {
        fontSize: '13px',
      },
      '& .MuiSelect-root': {
        fontSize: '13px',
        padding: '8px 12px',
      },
    },
  },
  select: {
    width: '100%',
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    width: '100%',
    '& .MuiTypography-root': {
      flex: 1,
    },
    [`@media (max-width: 768px)`]: {
      '& .MuiTypography-root': {
        fontSize: '14px',
      },
      '& .iconify': {
        fontSize: '20px',
      },
      padding: '8px',
    },
    [`@media (max-width: 480px)`]: {
      '& .MuiTypography-root': {
        fontSize: '13px',
      },
      '& .iconify': {
        fontSize: '18px',
      },
      padding: '6px',
    },
  },
  shareViewContent: {
    [`@media (max-width: 768px)`]: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
      '& .MuiFormControl-root, & .MuiButton-root': {
        width: '100%',
      },
      '& .settingsShare': {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '8px',
      },
    },
  },
})

export default styles
